import { Component, inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from '../../../services/setting.service';
import { RestaurantService } from '../../../services/restaurant.service';
import { Router } from '@angular/router';
import { FEATURE_FLAG_KEYS, FeatureFlag, isFeatureActive } from '../../../utils/feature-flag.util';
import { isPosManaged } from '../../../utils/pos-provider.util';

@Component({
  selector: 'app-tax-setting',
  standalone: true,
  imports: [],
  templateUrl: './tax-setting.component.html',
  styleUrl: './tax-setting.component.css',
})
export class TaxSettingComponent {
  restaurantService = inject(RestaurantService);
  router = inject(Router);
  ngxSpinnerService = inject(NgxSpinnerService);
  toastr = inject(ToastrService);
  isCheckedTaxFeature: boolean = false;
  settingService = inject(SettingService);
  currentRestaurantSettings: any;
  displayLoading: boolean = false;
  isShowTaxInBill: boolean = false;
  taxTypes: any = [
    { id: 1, name: 'Percentage', displayName: 'Percentage' },
    { id: 2, name: 'Fixed', displayName: 'Fixed' },
  ];
  selectedTaxType: any;
  restaurantPosProvider: string = 'fnf';

  constructor() {
    this.restaurantService.restaurantFeatureFlags$.subscribe((flags: FeatureFlag[] | null) => {
      if (flags && !isFeatureActive(flags, FEATURE_FLAG_KEYS.TAX)) {
        this.router.navigate(['/']);
        return;
      }
    });
    this.restaurantService.restaurantPosProvider$.subscribe((posProvider: any) => {
      this.restaurantPosProvider = posProvider;
      if (isPosManaged(this.restaurantPosProvider)) {
        this.router.navigate(['/']);
      }
    });
  }

  toggleTaxFeature(event: any) {
    this.isCheckedTaxFeature = event.target.checked;
  }

  toggleShowTaxInBill(event: any) {
    this.isShowTaxInBill = event.target.checked;
  }

  changeTaxType(taxType: any) {
    this.selectedTaxType = taxType.displayName;
  }
}
